export type TimeKey = '100' | '75' | '50' | '25' | '90' | '0' | 'locked';

// basisPoints: 0–10000 (hundredths of a percent)
export const timeKeyFromProgress = (basisPoints: number): TimeKey => {
  if (basisPoints <= 0) return '0';
  if (basisPoints <= 2500) return '25';
  if (basisPoints <= 5000) return '50';
  if (basisPoints <= 7500) return '75';
  if (basisPoints < 10000) return '90';
  return '100';
};

type GradientColors = { start: string; end: string };

export const colorsByTime: Record<TimeKey, GradientColors> = {
  '0': { start: '#B4E827', end: '#5CB800' },
  '25': { start: '#D4E827', end: '#88B300' },
  '50': { start: '#FFE040', end: '#FF8000' },
  '75': { start: '#FFAA88', end: '#FF4422' },
  '90': { start: '#FF5533', end: '#AA0000' },
  '100': { start: '#606060', end: '#2A2A2A' },
  locked: { start: '#D8D8D8', end: '#888888' },
};
